var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.35 20.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b5e83e30-6131-43e4-a511-0788bbe8a27c{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f49139ae-709e-42ec-9751-b1e7871350ab",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e4c30780-13e4-4bd3-8d94-a0ef5dd4aaea",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b5e83e30-6131-43e4-a511-0788bbe8a27c",
    x1: 0.18,
    y1: 0.18,
    x2: 20.18,
    y2: 20.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "b5e83e30-6131-43e4-a511-0788bbe8a27c",
    x1: 0.18,
    y1: 20.18,
    x2: 20.18,
    y2: 0.18
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBlack);
export default __webpack_public_path__ + "static/media/x-black.0539f7c5c2c783067633249ff3009706.svg";
export { ForwardRef as ReactComponent };